import Typography from "../components/shared/typography";
import { AmbientConvoList } from "../components/ambient/ambient-convo-list";
import { AmbientConvoDetail } from "../components/ambient/ambient-convo-detail";
import { AmbientConversationsProvider, useAmbientConversations } from "../hooks/AmbientConversationContextWrapper";
import { useLoadAmbientConversations } from "../hooks/useLoadAmbientConvos";

function AmbientConversationsPageContent() {
  const { conversations } = useLoadAmbientConversations();
  const {
    selectedConversation,
    setSelectedConversationId,
    getConvoAnalysis,
    deleteConversation,
  } = useAmbientConversations();

  const handleSelect = (id: string) => setSelectedConversationId(id);
  const handleAnalyze = (id: string) => {
    void getConvoAnalysis(id);
  };
  const handleDelete = (id: string) => {
    void deleteConversation(id);
  };

  return (
    <div className="container mx-auto px-4 py-8 grid md:grid-cols-2 gap-8">
      <div>
        <Typography variant="h3" className="mb-4 text-terracotta">
          Ambient Conversations
        </Typography>
        <AmbientConvoList items={conversations} onSelect={handleSelect} />
      </div>
      <div>
        <AmbientConvoDetail
          conversation={selectedConversation ?? null}
          onAnalyze={handleAnalyze}
          onDelete={handleDelete}
        />
      </div>
    </div>
  );
}

export default function AmbientConversationsPage() {
  return (
    <AmbientConversationsProvider>
      <AmbientConversationsPageContent />
    </AmbientConversationsProvider>
  );
}
